import React from "react";
import "./SurveyGraphSection.css";

export default function SurveyGraphSection({
  graphID,
  textPlacement,
  title,
  note,
  source,
  description,
  description2,
  customText,
  graphComponent,
  configuration,
  language,
  titleExtraPadding,
}) {
  return (
    <div
      className={
        "survey-graph-container" +
        (textPlacement === "right" ? " text-right" : "")
      }
    >
      <div className="survey-graph-text">
        <h1
          className={
            "survey-graph-title" +
            (titleExtraPadding ? " extra-padding-right" : "")
          }
        >
          {title}
        </h1>
        {description && <p className="survey-graph-description">{description}</p>}
        {description2 && <p className="survey-graph-description">{description2}</p>}
        {customText && <p className="survey-graph-custom-text">{customText}</p>}
        <div className="survey-graph-configuration">
          {configuration ?? null}
        </div>
        {note && <p className="survey-graph-note">{note}</p>}
        <p className="survey-graph-source">
          {language === "en" ? "Source:" : "Fuente:"} {source}
        </p>
      </div>
      <div id={graphID} className="survey-graph">
        {graphComponent}
      </div>
    </div>
  );
}
